export enum AdminTypes {
  ADMIN = 'ADMIN',
}
